// Vendor
import { useSelector } from 'react-redux';

// Components
import Text, { TextColor } from 'src/components/atoms/Text';
import { StyledCount } from './styles';

// Redux
import { selectors as propertySelectors } from 'src/features/property/propertySlice';

const PropertyListCount: React.FC = () => {
  const count = useSelector(propertySelectors.getAll.count);
  const error = useSelector(propertySelectors.getAll.error);
  const isIdle = useSelector(propertySelectors.getAll.isIdle);
  const isLoading = useSelector(propertySelectors.getAll.isLoading);

  if (error || isIdle || (isLoading && count === 0)) return null;

  return (
    <StyledCount>
      <Text color={TextColor.muted}>
        {count} {count === 1 ? 'result' : 'results'}
      </Text>
    </StyledCount>
  );
};

export default PropertyListCount;
